var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { xs: 9, sm: 6, md: 5, lg: 4, xl: 4 } },
            [
              _c(
                "div",
                { staticClass: "head-container" },
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    attrs: {
                      clearable: "",
                      size: "small",
                      placeholder: "输入部门名称搜索",
                      "prefix-icon": "el-icon-search",
                    },
                    on: { input: _vm.getDeptDatas },
                    model: {
                      value: _vm.deptName,
                      callback: function ($$v) {
                        _vm.deptName = $$v
                      },
                      expression: "deptName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tree", {
                attrs: {
                  data: _vm.deptDatas,
                  load: _vm.getDeptDatas,
                  props: _vm.defaultProps,
                  "expand-on-click-node": false,
                  lazy: "",
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 15, sm: 18, md: 19, lg: 20, xl: 20 } },
            [
              _c(
                "div",
                { staticClass: "head-container" },
                [
                  _vm.crud.props.searchToggle
                    ? _c(
                        "div",
                        [
                          _c("el-input", {
                            staticClass: "filter-item",
                            staticStyle: { width: "200px" },
                            attrs: {
                              clearable: "",
                              size: "small",
                              placeholder: "输入名称或者邮箱搜索",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.crud.toQuery($event)
                              },
                            },
                            model: {
                              value: _vm.query.blurry,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "blurry", $$v)
                              },
                              expression: "query.blurry",
                            },
                          }),
                          _vm._v(" "),
                          _c("date-range-picker", {
                            staticClass: "date-item",
                            model: {
                              value: _vm.query.createTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.query, "createTime", $$v)
                              },
                              expression: "query.createTime",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              staticStyle: { width: "90px" },
                              attrs: {
                                clearable: "",
                                size: "small",
                                placeholder: "状态",
                              },
                              on: { change: _vm.crud.toQuery },
                              model: {
                                value: _vm.query.enabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.query, "enabled", $$v)
                                },
                                expression: "query.enabled",
                              },
                            },
                            _vm._l(_vm.enabledTypeOptions, function (item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: {
                                  label: item.display_name,
                                  value: item.key,
                                },
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c("rrOperation"),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("crudOperation", {
                    attrs: { show: "", permission: _vm.permission },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    "append-to-body": "",
                    "close-on-click-modal": false,
                    "before-close": _vm.crud.cancelCU,
                    visible: _vm.crud.status.cu > 0,
                    title: _vm.crud.status.title,
                    width: "570px",
                  },
                  on: {
                    "update:visible": function ($event) {
                      return _vm.$set(_vm.crud.status, "cu > 0", $event)
                    },
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: {
                        inline: true,
                        model: _vm.form,
                        rules: _vm.rules,
                        size: "small",
                        "label-width": "66px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户名", prop: "username" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.username,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "username", $$v)
                              },
                              expression: "form.username",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "电话", prop: "phone" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "phone", _vm._n($$v))
                              },
                              expression: "form.phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "昵称", prop: "nickName" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.nickName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "nickName", $$v)
                              },
                              expression: "form.nickName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱", prop: "email" } },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.form.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "部门", prop: "dept.id" } },
                        [
                          _c("treeselect", {
                            staticStyle: { width: "437px" },
                            attrs: {
                              options: _vm.depts,
                              "load-options": _vm.loadDeptOptions,
                              placeholder: "选择部门",
                            },
                            model: {
                              value: _vm.form.dept.id,
                              callback: function ($$v) {
                                _vm.$set(_vm.form.dept, "id", $$v)
                              },
                              expression: "form.dept.id",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "岗位", prop: "jobs" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "437px" },
                              attrs: {
                                filterable: "",
                                multiple: "",
                                placeholder: "请选择",
                              },
                              on: {
                                "remove-tag": _vm.deleteTag,
                                change: _vm.changeJob,
                              },
                              model: {
                                value: _vm.jobDatas,
                                callback: function ($$v) {
                                  _vm.jobDatas = $$v
                                },
                                expression: "jobDatas",
                              },
                            },
                            _vm._l(_vm.jobs, function (item) {
                              return _c("el-option", {
                                key: item.name,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "性别" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "178px" },
                              model: {
                                value: _vm.form.gender,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "gender", $$v)
                                },
                                expression: "form.gender",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "男" } }, [
                                _vm._v("男"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "女" } }, [
                                _vm._v("女"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.form.id === _vm.user.id },
                              model: {
                                value: _vm.form.enabled,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "enabled", $$v)
                                },
                                expression: "form.enabled",
                              },
                            },
                            _vm._l(_vm.dict.user_status, function (item) {
                              return _c(
                                "el-radio",
                                { key: item.id, attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "绑定酷家乐",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "200px" },
                              model: {
                                value: _vm.form.isKuJiaLe,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isKuJiaLe", $$v)
                                },
                                expression: "form.isKuJiaLe",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "是" } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "否" } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                disabled: !_vm.form.id,
                              },
                              on: { click: _vm.bindKuJiaLeAccount },
                            },
                            [_vm._v("绑定酷家乐账号")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否为审核人员",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticStyle: { width: "300px" },
                              model: {
                                value: _vm.form.isReviewer,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isReviewer", $$v)
                                },
                                expression: "form.isReviewer",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "是" } }, [
                                _vm._v("是"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "否" } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-bottom": "0" },
                          attrs: { label: "角色", prop: "roles" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "437px" },
                              attrs: {
                                filterable: "",
                                multiple: "",
                                placeholder: "请选择",
                              },
                              on: {
                                "remove-tag": _vm.deleteTag,
                                change: _vm.changeRole,
                              },
                              model: {
                                value: _vm.roleDatas,
                                callback: function ($$v) {
                                  _vm.roleDatas = $$v
                                },
                                expression: "roleDatas",
                              },
                            },
                            _vm._l(_vm.roles, function (item) {
                              return !(
                                _vm.level !== 1 && item.level <= _vm.level
                              )
                                ? _c("el-option", {
                                    key: item.name,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                : _vm._e()
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.crud.cancelCU },
                        },
                        [_vm._v("取消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.crud.status.cu === 2,
                            type: "primary",
                          },
                          on: { click: _vm.crud.submitCU },
                        },
                        [_vm._v("确认")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.crud.loading,
                      expression: "crud.loading",
                    },
                  ],
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.crud.data },
                  on: { "selection-change": _vm.crud.selectionChangeHandler },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      selectable: _vm.checkboxT,
                      type: "selection",
                      width: "55",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      prop: "username",
                      label: "用户名",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      prop: "nickName",
                      label: "昵称",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "gender", label: "性别", width: "55" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      prop: "phone",
                      width: "100",
                      label: "电话",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      width: "125",
                      prop: "email",
                      label: "邮箱",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      prop: "dept",
                      label: "部门",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(scope.row.dept && scope.row.dept.name)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "岗位",
                      width: "110",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return _vm._l(scope.row.jobs, function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item.id,
                                attrs: { type: item.name, effect: "plain" },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          })
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", align: "center", prop: "enabled" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                disabled: _vm.user.id === scope.row.id,
                                "active-color": "#409EFF",
                                "inactive-color": "#F56C6C",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeEnabled(
                                    scope.row,
                                    scope.row.enabled
                                  )
                                },
                              },
                              model: {
                                value: scope.row.enabled,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "enabled", $$v)
                                },
                                expression: "scope.row.enabled",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      prop: "createTime",
                      width: "135",
                      label: "创建日期",
                    },
                  }),
                  _vm._v(" "),
                  _vm.checkPer(["admin", "user:edit", "user:del"])
                    ? _c("el-table-column", {
                        attrs: {
                          label: "执行",
                          width: "115",
                          align: "center",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("TransCust", {
                                    ref: "transCust",
                                    attrs: { transUser: scope.row },
                                  }),
                                  _vm._v(" "),
                                  _c("AsycCust", {
                                    ref: "asycCust",
                                    attrs: { user: scope.row },
                                  }),
                                  _vm._v(" "),
                                  _vm.checkPer(["admin", "user:reset"])
                                    ? _c(
                                        "el-button",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.resetPass(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("重置密码")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2252346432
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.checkPer(["admin", "user:edit", "user:del"])
                    ? _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          width: "115",
                          align: "center",
                          fixed: "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("udOperation", {
                                    attrs: {
                                      data: scope.row,
                                      permission: _vm.permission,
                                      "disabled-dle":
                                        scope.row.id === _vm.user.id,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2806016545
                        ),
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }